import withAemIntegration from "../../withAemIntegration";
import loadable from "@loadable/component";

const Component = loadable(() =>
  import("@lexus.com/ui/dist/components/DigitalGarage/SavesPage")
);


const DGSavesPageEditConfig = {
  emptyLabel: "DG Saves Page",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const DGSavesPage = (props) => {
  return <Component {...props} />;
};

export default withAemIntegration("lexus/components/digital-garage-saves")(
  DGSavesPage,
  DGSavesPageEditConfig
);
